import settings from 'shared/settings';

export const vodAdapterSettings = {
  apiUrl: settings.hosts.catalog,
  filesUrl: settings.hosts.files,
  uploadLimits: {
    secureVideo: 16106127360,
  },
};



// WEBPACK FOOTER //
// ./src/shared/utils/adapters/config.js